import { CartItem } from '../state/types';
import { getItemFromCart, getQuantityFromItem, isServiceCartItem } from '../state/utils';

const mergeCartItemDescription = (cartItem: CartItem) => {
  const item = getItemFromCart(cartItem);
  let result = `${getQuantityFromItem(cartItem) > 1 ? `${getQuantityFromItem(cartItem)}*` : ''}${item.name}:`;
  const cartItemEntity = isServiceCartItem(cartItem) ? cartItem.service : cartItem.pricingForm;
  if (cartItemEntity.question1) {
    result = `${result}\n1.${cartItemEntity.question1}:\n- ${cartItem.question_1 || 'no answer provided'}\n`;
  }
  if (cartItemEntity.question2) {
    result = `${result}\n2.${cartItemEntity.question2}:\n- ${cartItem.question_2 || 'no answer provided'}\n`;
  }
  if (!cartItemEntity.question1 && !cartItemEntity.question2) {
    result = `${result}\nDescription:\n- ${cartItem.description || 'no description provided'}\n`;
  }

  return `${result}\n\n`;
};

export const mergeDescription = (cartItems: CartItem[]): string => {
  return cartItems.map(mergeCartItemDescription).join('').trim();
};
